module.exports = __webpack_public_path__ + "static/media/icon-mascot.16528f00.svg";